<template>
  <div>
    <exo-table :root="_self">
      <exo-form :root="_self">
        <exo-input-name :root="_self" />
        <exo-input-double :root="_self" name="thrust" />
        <exo-input-double :root="_self" name="isp" />
        <exo-input-select :root="_self" name="propulsionSystemType">
          <exo-help-dialog title="Propulsion system type">
            <tooltipPropulsionSystemType />
          </exo-help-dialog>
        </exo-input-select>
        <exo-input-double :root="_self" name="maximumThrustDuration">
          <exo-help-dialog title="Maximum thrust duration">
            <tooltipMaxThrustDuration />
          </exo-help-dialog>
        </exo-input-double>
        <exo-input-double :root="_self" name="power" />
        <exo-input-double :root="_self" name="standbyPower">
          <exo-help-dialog title="Standby power">
            <tooltipStandByPower />
          </exo-help-dialog>
        </exo-input-double>
        <exo-input-double :root="_self" name="warmUpDuration">
          <exo-help-dialog title="Warm-up">
            <tooltipWarmUp />
          </exo-help-dialog>
        </exo-input-double>
        <exo-input-double :root="_self" name="warmUpPower" />
        <exo-input-double :root="_self" name="totalMass" />
        <exo-input-select :root="_self" name="propellantCapacityChoice">
          <exo-help-dialog title="Propellant capacity">
            <tooltipPropellantCapacity />
          </exo-help-dialog>
        </exo-input-select>
        <exo-input-double
          :root="_self"
          name="propellantMass"
          tooltip="Already included in the total mass"
        />
        <exo-input-double :root="_self" name="totalImpulse" />
      </exo-form>
    </exo-table>
    <exo-modal-references :root="_self" :modalContent="this.modalRef" />
  </div>
</template>

<script>
import formMixin from '../../mixins/forms.js'
import numericalMixin from '../../mixins/numericalForms.js'
import dataTools from '../../tools/data'
import fieldsDescription from '../../tools/fieldsDescription'
import tooltipPropulsionSystemType from '../../components/Tooltips/Simulations/tooltipPropulsionSystemType'
import tooltipStandByPower from '../../components/Tooltips/Simulations/tooltipStandByPower'
import tooltipWarmUp from '../../components/Tooltips/Simulations/tooltipWarmUp'
import tooltipPropellantCapacity from '../../components/Tooltips/Simulations/tooltipPropellantCapacity'
import tooltipMaxThrustDuration from '../../components/Tooltips/Simulations/tooltipMaxThrustDuration'

export default {
  name: 'thruster',
  components: {
    tooltipPropulsionSystemType,
    tooltipStandByPower,
    tooltipWarmUp,
    tooltipPropellantCapacity,
    tooltipMaxThrustDuration
  },
  mixins: [formMixin, numericalMixin],

  computed: {},

  data() {
    return {
      tableFields: [
        { value: 'displayedName', text: 'Name', sortable: true },
        {
          value: 'isp',
          text: 'Isp' + this.getDefaultUnitLabel('isp'),
          sortable: true
        },
        {
          value: 'power',
          text: 'Power' + this.getDefaultUnitLabel('power'),
          sortable: true
        },
        {
          value: 'thrust',
          text: 'Thrust' + this.getDefaultUnitLabel('thrust'),
          sortable: true
        },
        {
          value: 'totalMass',
          text: 'Total mass' + this.getDefaultUnitLabel('totalMass'),
          sortable: true
        },
        {
          value: 'propellantMass',
          text: 'Propellant' + this.getDefaultUnitLabel('propellantMass'),
          sortable: true
        },
        {
          value: 'totalImpulse',
          text: 'Total impulse' + this.getDefaultUnitLabel('totalImpulse'),
          sortable: true
        },
        { value: 'actions', text: 'Actions', sortable: false }
      ],

      modalRef: { content: [] },
      showModal: false,

      enumPropertiesList: this.getEnumProperties(),

      inputs: {
        isp: this.getDefaultValue('isp'),
        power: this.getDefaultValue('power'),
        thrust: this.getDefaultValue('thrust'),
        maximumThrustDuration: this.getDefaultValue('maximumThrustDuration'),
        propulsionSystemType: this.getDefaultValue('propulsionSystemType'),
        propellantCapacityChoice: this.getDefaultValue(
          'propellantCapacityChoice'
        ),
        totalMass: this.getDefaultValue('totalMass'),
        propellantMass: this.getDefaultValue('propellantMass'),
        totalImpulse: this.getDefaultValue('totalImpulse'),
        standbyPower: this.getDefaultValue('standbyPower'),
        warmUpPower: this.getDefaultValue('warmUpPower'),
        warmUpDuration: this.getDefaultValue('warmUpDuration'),
        scope: this.getDefaultValue('scope')
      }
    }
  },

  methods: {
    getCurrentFormType() {
      return 'PropulsionSystemDefinition'
    },
    getRequiredPropertiesList(instance) {
      let subTypes = this.getSubTypes(instance)
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        subTypes,
        'required'
      )
      return requiredList
    },

    getOptionalPropertiesList(instance) {
      let subTypes = this.getSubTypes(instance)
      let objectType = this.getCurrentFormType()
      return dataTools.getPropertiesList(
        fieldsDescription[objectType],
        subTypes,
        'optional'
      )
    },

    getAllPropertiesUnionList() {
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        null,
        'required'
      )
      let optionalList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        null,
        'optional'
      )
      return [...new Set(requiredList.concat(optionalList))]
    },

    getSubTypes(instance) {
      let types = {
        propulsionSystemType: instance.propulsionSystemType,
        propellantCapacityChoice: instance.propellantCapacityChoice
      }
      return types
    },

    getFieldState(parentObject, fieldName, required) {
      let fieldState = numericalMixin.methods.getFieldState.call(
        this,
        parentObject,
        fieldName,
        required
      )
      return fieldState
    },

    getRefList(param) {
      return []
    }
  }
}
</script>

<style scoped>
.label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54) !important;
}
</style>
